import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios'
import { toast } from 'react-toastify';

export const updateApi = createAsyncThunk(
    "apis/updateApi",
    async ({ id, formData, token }, { rejectWithValue }) => {
        try {

            console.log(formData)
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/apiKeys`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        id
                    }
                }
            );

            if (response.status === 200 && response.data.status) {


                return response.data;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (error) {
            return rejectWithValue(error.response?.data.message || "Error updating Api");
        }
    }
);

export const deleteApi = createAsyncThunk(
    "apis/deleteApi",
    async ({ key, token }, { rejectWithValue }) => {
        try {


            const response = await axios.delete(
                `${process.env.REACT_APP_BASE_URL}/apiKeys`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        id: parseInt(key)
                    }
                }
            );


            if (response.status === 200 || response.statusCode === 200) {
                return { status: response.data.status, key: key };
            } else {

                return rejectWithValue(response.data?.message || "Failed to delete link");
            }
        } catch (error) {

            if (error.response?.status === 400) {
                toast.error("Bad Request: Please check the API or try again.");
            } else if (error.response?.status === 404) {
                toast.error("API not found: The link you're trying to delete doesn't exist.");
            } else {

                toast.error(error.response?.data?.message || "Error deleting API");
            }

            return rejectWithValue(
                error.response?.data?.message || error.message || "Network error"
            );
        }
    }
);

export const toggleApiStatus = createAsyncThunk(
    "api/toggleapiStatus",
    async ({ key, token }, { rejectWithValue }) => {

        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/apikeys/${key}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },

                }
            );

            if (response.data.status) {
                // toast.success(response.data.response);
                return {key,response:response.data}
            } else {
                return rejectWithValue("Failed ");
            }
        } catch (error) {

            return rejectWithValue(
                error.response?.data || "Error "
            );
        }
    }
);

export const createApi = createAsyncThunk(
    "Api/createApi",
    async ({ token, formData }, { rejectWithValue }) => {
        try {

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/apikeys`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },

                }
            );

            if (response.data.status) {

                return response.data;
            } else {
                return rejectWithValue("Failed ");
            }
        } catch (error) {
            return rejectWithValue(error.message || "Network error");
        }
    }
);

export const getApis = createAsyncThunk(
    "apis/get-apis",
    async ({ token, offset = 1, limit = 10 }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/apikeys/list`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        offset, limit
                    }

                }
            );

            if (response.data.status) {
                console.log(response.data.response)
                return { status: response.data.status, response: response.data.response };
            } else {
                return rejectWithValue("Failed to fetch ");
            }
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Network error"
            );
        }
    }
);

const apiSlice = createSlice({
    name: 'api',
    initialState: {
        apiList: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getApis.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getApis.fulfilled, (state, action) => {
                state.loading = false;
                state.apiList = action.payload.response;
            })
            .addCase(getApis.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;

            })
            .addCase(deleteApi.pending, (state) => {
                state.loading = true
            })
            .addCase(deleteApi.fulfilled, (state, action) => {
                state.loading = false
                state.apiList = state.apiList.filter(
                    (api) => api.apiKeyId !== action.payload.key
                );
                toast.success("Api deleted successfully! ");
            })
            .addCase(deleteApi.rejected, (state, action) => {

                state.loading = false

                if (action.payload) {
                    toast.error(action.payload);
                } else {
                    toast.error("Error deleting link");
                }
            })
            .addCase(updateApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateApi.fulfilled, (state, action) => {
                state.loading = false;
                toast.success("API updated successfully!");
            })
            .addCase(updateApi.rejected, (state, action) => {
                state.loading = false;
                toast.error(action.payload || "Failed to update API.");
            })
            .addCase(createApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(createApi.fulfilled, (state, action) => {
                state.loading = false;

                toast.success("API created successfully!");
            })
            .addCase(createApi.rejected, (state, action) => {
                state.loading = false;
                toast.error(action.payload || "Failed to create API.");
            })
            .addCase(toggleApiStatus.pending, (state) => {
                state.loading = true;
            })
            .addCase(toggleApiStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.apiList = state.apiList.map((api) => {
                    if (api.apiKeyId === action.payload.key) {
                        return { ...api, status: api.status === 1 ? 0 : 1 };
                    }
                    return api;
                });
                toast.success(action.payload.response.response);
            })
            .addCase(toggleApiStatus.rejected, (state, action) => {
                state.loading = false;
                toast.error(action.payload || "Failed to toggle API.");
            })


    },
});

export default apiSlice.reducer;